<template>
    <div class="breadcrumb">
      <button class="breadcrumb__back-navigation" @click="goBack">
          <svg aria-hidden="true">
              <use :xlink:href="'#back-navigation'"></use>
          </svg>
      </button>
      <a
        v-if="productTypeLink"
        class="breadcrumb__product-type"
        :href="productTypeLink"
      >
        {{ formattedProductType }} Clothing
      </a>
      <template v-for="(crumb, index) in breadcrumbs" :key="index">
        <span class="breadcrumb__separator">&nbsp;/ </span>
        <a class="breadcrumb__crumb" :href="crumb.url">{{ crumb.label }}</a>
      </template>
      <span class="breadcrumb__product">&nbsp;/ {{ product.title }}</span>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true
    }
  });

  const breadcrumbs = computed(() => props.product?.breadcrumbs || []);
  
  const formattedProductType = computed(() => {
    const type = props.product?.type
    if (type === 'Unisex' || type === 'Gift Card') return 'All'
    if (type === 'Digital') return 'Personal Shopping Experience'
    return type
  });
  
  const productTypeLink = computed(() => {
    const type = props.product?.type
    if (type === 'Unisex' || type === 'Gift Card') {
      return '/collections/master-collection'
    } else if (type === 'Digital') {
      return '/collections/personal-shopping-experience'
    } else {
      return '/collections/' + (type || '').replace(/'/g, '').toLowerCase().replace(/\s+/g, '-')
    }
  });

  const goBack = () => {
    window.history.back();
  };
  </script>
